import React, { useEffect, useState } from 'react';
import { collection, getDocs, updateDoc, doc, query, orderBy } from 'firebase/firestore';
import { db } from './firebase';
import { format } from 'date-fns';

export default function Embajadoras() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState('aprobadas'); // 'aprobadas' | 'pendientes'

  async function load() {
    setLoading(true);
    const snap = await getDocs(collection(db, 'users'));
    const rows = [];
    snap.forEach(d => rows.push({ id: d.id, ...d.data() }));
    setUsers(rows.filter(u => u.role !== 'admin'));
    setLoading(false);
  }

  useEffect(() => { load(); }, []);

  async function approve(uid) {
    await updateDoc(doc(db, 'users', uid), { approved: true });
    await load();
  }

  async function revoke(uid) {
    if (!window.confirm('¿Revocar acceso de esta embajadora?')) return;
    await updateDoc(doc(db, 'users', uid), { approved: false });
    await load();
  }

  const displayed = users.filter(u => tab === 'aprobadas' ? u.approved : !u.approved);

  return (
    <div>
      <div className="page-header">
        <h1>Embajadoras</h1>
        <p>Gestión de usuarias del sistema</p>
      </div>
      <div className="page-body">
        <div className="tabs">
          <button className={`tab${tab === 'pendientes' ? ' active' : ''}`} onClick={() => setTab('pendientes')}>
            Pendientes {users.filter(u => !u.approved).length > 0 && `(${users.filter(u => !u.approved).length})`}
          </button>
          <button className={`tab${tab === 'aprobadas' ? ' active' : ''}`} onClick={() => setTab('aprobadas')}>
            Aprobadas ({users.filter(u => u.approved).length})
          </button>
        </div>

        {tab === 'pendientes' && displayed.length > 0 && (
          <div className="alert-item alert-warning" style={{ marginBottom: 16 }}>
            ⚡ Hay {displayed.length} embajadora{displayed.length > 1 ? 's' : ''} esperando aprobación para usar el sistema.
          </div>
        )}

        <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
          <div className="table-wrap">
            {loading ? <div className="spinner" /> : (
              <table>
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Email</th>
                    <th>Teléfono</th>
                    <th>Zona</th>
                    <th>Registro</th>
                    <th>Estado</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {displayed.length === 0 ? (
                    <tr><td colSpan={7} style={{ textAlign: 'center', color: 'var(--gray-light)', padding: 40 }}>Sin usuarias</td></tr>
                  ) : displayed.map(u => (
                    <tr key={u.id}>
                      <td style={{ fontWeight: 600 }}>{u.name}</td>
                      <td style={{ color: 'var(--gray-light)' }}>{u.email}</td>
                      <td>{u.phone || '-'}</td>
                      <td>{u.zone || '-'}</td>
                      <td style={{ color: 'var(--gray-light)' }}>
                        {u.createdAt ? format(u.createdAt.toDate ? u.createdAt.toDate() : new Date(u.createdAt), 'dd/MM/yy') : '-'}
                      </td>
                      <td>
                        <span className={`badge ${u.approved ? 'badge-green' : 'badge-yellow'}`}>
                          {u.approved ? 'Aprobada' : 'Pendiente'}
                        </span>
                      </td>
                      <td>
                        {!u.approved ? (
                          <button className="btn btn-primary btn-sm" onClick={() => approve(u.id)}>
                            Aprobar
                          </button>
                        ) : (
                          <button className="btn btn-danger btn-sm" onClick={() => revoke(u.id)}>
                            Revocar
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}